//
//
//
//
//
//
//
//
//
//
//

const DEFAULT_QR = 'weixin-qr.jpg'

const QR_MAP = {
    daily_report: 'daily_report.png',
    trade_data: 'jysj.jpeg',
    zgcx: 'zgcx.jpeg',
    latest_lotted: 'zgcx.jpeg',
    question: 'gfdy.jpeg',
    material: 'gfzl.jpeg',
    prepayment: 'prepayment.png'
}

export default {
    props: {
        type: {
            type: String,
            default: ''
        },
        festival: {
            type: Boolean,
            default: false
        },
        undertint: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        qr () {
            return `https://cdn.vip-wifi.com/fangchan/img/qr/chengdu/${QR_MAP[this.type] || DEFAULT_QR}`
        }
    }
}
